<ng-container *ngIf="!loadFailed; else loadError">
  <div class="white-box-header">
    <div class="medium-title fl-l">
      {{ "COMPANY.ACCOUNT-SCOPES.TITLE" | translate }}
    </div>
  </div>
  <div class="clear"></div>

  <div class="white-box-body account-scopes">
    <!-- Providers -->
    <div
      class="account-scopes__provider"
      *ngFor="let driver of drivers; let first = first"
      [class.account-scopes__provider--divided]="!first"
    >
      <div
        class="account-scopes__provider-head"
        [class.account-scopes__provider-head--expanded]="driver.expanded"
        (click)="toggleExpand(driver)"
      >
        <div class="account-scopes__brand">
          <img
            *ngIf="driver.isGoogle"
            class="account-scopes__brand-img"
            src="assets/icons/gmail.svg"
            alt=""
            aria-hidden="true"
          />
          <img
            *ngIf="driver.isMicrosoft"
            class="account-scopes__brand-img"
            src="assets/icons/outlook.svg"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div class="account-scopes__provider-meta">
          <div class="account-scopes__provider-title">
            {{ driver.titleKey | translate }}
          </div>
          <div class="account-scopes__provider-subtitle">
            {{ driver.subtitleKey | translate }}
          </div>
        </div>
        <i
          class="account-scopes__chevron icon-angle-down"
          aria-hidden="true"
        ></i>
      </div>

      <div class="account-scopes__provider-body" *ngIf="driver.expanded">
        <!-- Always requested -->
        <div class="account-scopes__always" *ngIf="driver.locked.length">
          <div class="account-scopes__always-head">
            <i
              class="account-scopes__always-icon icon-ok"
              aria-hidden="true"
            ></i>
            <span class="account-scopes__always-label">
              {{ "COMPANY.ACCOUNT-SCOPES.ALWAYS-INCLUDED" | translate }}
            </span>
            <span class="account-scopes__always-hint">
              {{ "COMPANY.ACCOUNT-SCOPES.ALWAYS-HINT" | translate }}
            </span>
          </div>
          <div class="account-scopes__chips">
            <span
              class="account-scopes__chip"
              *ngFor="let scope of driver.locked"
            >
              {{ scope.display }}
            </span>
          </div>
        </div>

        <!-- Optional scope groups -->
        <div class="account-scopes__group" *ngFor="let group of driver.groups">
          <div class="account-scopes__group-head">
            <span class="account-scopes__group-name">{{ group.name }}</span>
            <span
              class="account-scopes__group-toggle"
              (click)="toggleGroup(driver, group)"
            >
              {{
                (isGroupAllSelected(driver, group)
                  ? "COMPANY.ACCOUNT-SCOPES.CLEAR-ALL"
                  : "COMPANY.ACCOUNT-SCOPES.SELECT-ALL"
                ) | translate
              }}
            </span>
          </div>
          <div
            class="account-scopes__row"
            *ngFor="let row of group.rows"
            (click)="toggle(driver, row.value)"
          >
            <span
              class="account-scopes__box"
              [class.account-scopes__box--checked]="
                isSelected(driver, row.value)
              "
            >
              <i
                *ngIf="isSelected(driver, row.value)"
                class="account-scopes__check icon-ok"
                aria-hidden="true"
              ></i>
            </span>
            <span class="account-scopes__row-label">{{ row.label }}</span>
            <span class="account-scopes__row-scope">{{ row.display }}</span>
          </div>
        </div>

        <!-- Per-provider action bar -->
        <div class="account-scopes__actions">
          <button
            type="button"
            class="as-btn as-btn--primary"
            [disabled]="!isDirty(driver) || driver.saving"
            (click)="saveDriver(driver)"
          >
            {{
              (driver.saving
                ? "COMPANY.ACCOUNT-SCOPES.SAVING"
                : "COMPANY.ACCOUNT-SCOPES.SAVE"
              ) | translate
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadError>
  <div class="white-box-header">
    <div class="medium-title fl-l">
      {{ "COMPANY.ACCOUNT-SCOPES.TITLE" | translate }}
    </div>
  </div>
  <div class="clear"></div>
  <div class="white-box-body">
    <p class="account-scopes__error">
      {{ "COMPANY.ACCOUNT-SCOPES.LOAD-ERROR" | translate }}
    </p>
  </div>
</ng-template>
